module.exports = __webpack_public_path__ + "media/images/question_mark-2760f174e78f66776c1343e5564be0d5.svg";